import React from "react";
import { CalendarField, DropDownField } from "../helpers";
import { RadioButton } from "primereact/radiobutton";


const DateFilter = (props) => {
    const {eachOption, searchParams, handleDateRangeChange, handleSearchOnChange, dateOptions, removeFilterOption} = props

    let minDate = new Date()
    if(searchParams["fromDate"]){
        minDate = new Date(searchParams["fromDate"])
    }

    return (
        <div className='date-section date-filter-set'>
            {!eachOption.static ?
                <div className="flex justify-content-end p-0 col-12 remove-opt">
                    <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                </div>
                :
                null
            }
            <div className="flex flex-column col-12">
                <DropDownField name="dateType" labelText="Date Type" options={eachOption.options} value={searchParams["dateType"]} onChange={handleSearchOnChange} />
            </div>
            <div className="flex flex-row justify-content-between col-12 pb-0">
                {
                    dateOptions.map(eachDateOption => {
                        return (
                            <div className="flex flex-row mr-1">
                                <RadioButton inputId={eachDateOption} value={eachDateOption} checked={searchParams.range === eachDateOption} onChange={() => handleDateRangeChange(eachDateOption)} />
                                <label htmlFor={eachDateOption} className="text-xs cursor-pointer">{eachDateOption}</label>
                            </div>
                        )
                    })
                }
            </div>
            <div className='flex justify-content-between col-12 align-item-center pl-0 pt-0'>
                <div className="flex flex-column col-6 pb-0">
                    <CalendarField name="fromDate" value={searchParams["fromDate"] ? new Date(searchParams["fromDate"]) : null} onChange={handleSearchOnChange} disabled={eachOption.disabled} />
                </div>
                <span className='align-self-center mt-2'>-</span>
                <div className="flex flex-column col-6 pb-0">
                    <CalendarField name="toDate" value={searchParams["toDate"] ? new Date(searchParams["toDate"]) : null} onChange={handleSearchOnChange} minDate={minDate} disabled={eachOption.disabled || !searchParams["fromDate"]} />
                </div>
            </div>
        </div>
    )
}

export default DateFilter;